/**
 * Builds the durable, shareable purchase link for an Assessment Package.
 *
 * The link targets the API's public `GET /buy/:id` route (which mints a Stripe
 * Checkout Session on click), so it's built from the same server URL the API
 * client uses — not the web app origin. It never expires and is reusable by
 * many customers; the price is resolved from the DB at click time.
 */
export const buildPackageBuyUrl = (packageId: string): string => {
  const base = (import.meta.env.VITE_SERVER_URL || '').replace(/\/$/, '');
  return `${base}/buy/${packageId}`;
};
